import { AuditCampaign } from "@skinsoft/types";
import { SEARCH_TYPES } from "@skinsoft/const";

import { AuditCampaignDataStore } from "@skinsoft/entity";
import { CACHE_KEYS, AuditCampaignOfflineDataFetcher } from "@skinsoft/offline";
import { EntitySyncDownHandler } from "../../entity-sync-down-handler";

declare const config
const SEARCH_PAGE_SIZE = config.syncDownPageSize.auditCampaign ?? config.syncDownPageSize.default

export class AuditCampaignSyncDownHandler extends EntitySyncDownHandler<AuditCampaign, AuditCampaign, AuditCampaign> {
    private static instance: AuditCampaignSyncDownHandler = null as any

    public static getInstance() {
        if (!AuditCampaignSyncDownHandler.instance) {
            AuditCampaignSyncDownHandler.instance = new AuditCampaignSyncDownHandler()
        }

        return AuditCampaignSyncDownHandler.instance
    }

    public static install(Vue) {
        AuditCampaignSyncDownHandler.getInstance()
    }

    constructor() {
        super(
            [SEARCH_TYPES.auditCampaign],
            AuditCampaignDataStore.getInstance(),
            new AuditCampaignOfflineDataFetcher(),
            CACHE_KEYS.AuditCampaign,
            SEARCH_PAGE_SIZE
        )
    }
}